import { environmentHttpClient } from "client/Api/httpClient";
import { UserRequestItemClientModel } from "client/Api/UserRequests/manageUserRequests";

export const enum UserRequestKind {
	AppAccess = 1
};

export const enum UserRequestStatus {
	Open = 0,
	Accepted = 1,
	Declined = 2
}

export type MakeUserRequestAppItemModel = {
	id: number;
};

export type MakeUserRequestItemModel = {
	app: MakeUserRequestAppItemModel | null;
};

export type MakeUserRequestModel = {
	item: MakeUserRequestItemModel;
	reasonForRequest: string;
};

export type UserRequestResponseClientModel = {
	status: Exclude<UserRequestStatus, UserRequestStatus.Open>;
	note: string | undefined;
	item: UserRequestItemClientModel;
};

export function makeUserRequest(
	model: MakeUserRequestModel
): Promise<void> {
	return environmentHttpClient.post<void> (
		"/UserRequests/",
		model
	);
}

export function getUserRequestResponse(
	id: number,
	signal?: AbortSignal
): Promise<UserRequestResponseClientModel> {
	return environmentHttpClient.get<UserRequestResponseClientModel> (
		`/UserRequests/${id}/Response`,
		null,
		{ signal }
	);
}